import { CurrenciesAllowedEnum } from "@tutellus/core-contracts-ifaces"
import { ToastProps } from "@tutellus/tutellus-components"
import React from "react"

// STORAGE KEYS
export const THEME_MODE_STORAGE_KEY = "theme-mode"
export const CURRENCY_STORAGE_KEY = "currency"

// CONTEXT
interface LayoutContextInterface {
  themeMode: ThemeMode
  setThemeMode: (mode: ThemeMode) => void
  currencyID: CurrenciesAllowedEnum
  setCurrencyID: (currency: CurrenciesAllowedEnum) => void
  addToast: (toast: Omit<ToastProps, "id" | "isExiting" | "onClose"> & { duration?: number }) => void
  removeToast: (id: string) => void
  clearAllToasts: () => void
}

interface LayoutProviderProps extends React.PropsWithChildren {}

// THEME
enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export { type LayoutContextInterface, type LayoutProviderProps, ThemeMode }
